import { Component } from '@angular/core';
import { NavController, LoadingController, NavParams, ToastController, PopoverController } from 'ionic-angular';

import { UserService } from '../../../../services/user.service';
import { AlertMessager } from '../../../../lib/alertMessager';
import { Account } from '../../../../model/account';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Membership } from '../../../../model/membership';
import { OrganizationService } from '../../../../services/organization.service';
import { Organization } from '../../../../model/organization';
import { AccountMembership } from '../../../../model/accountMembership';
import { UserSearchPopover } from '../../../search/user-search';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { DataService } from '../../../../services/data';
import { NewMembership } from './new-membership';
import { AccountFamily } from '../../../../model/accountFamily';
import { MembershipHandicap } from '../../../../model/membershipHandicap';

@Component({
    selector: 'page-new-member',
    templateUrl: 'new-member.html'
})
export class NewMemberPage {
    callback: any;

    account: Account = new Account();
    secondUser: Account = new Account();
    newUser: Account = new Account();

    popoverActive: boolean;

    organizations: Organization[] = [];
    memberships: Membership[] = [];
    selectedMemberships: Membership[] = [];

    eventRoperSelected: string = 'editRoper:selected';

    roperSearchChangeObservable;
	roper2SearchChangeObservable;
    roperSubHandler: any;
    
    roperSelected: boolean = false;

    profileForm: FormGroup;
    submitAttempt: boolean;
    validationMessages: any[] = [];

    constructor(public nav: NavController, private alertMessager: AlertMessager, navParams: NavParams, public organizationService: OrganizationService, 
        public userService: UserService, public loadingCtrl: LoadingController, private popoverCtrl: PopoverController, private formBuilder: FormBuilder,
        public data: DataService, private toast: ToastController) {
        this.callback = navParams.get('callback');
        this.account = navParams.get('account');
        this.organizations = navParams.get('organizations');
        let firstName = navParams.get('firstName');
        let lastName = navParams.get('lastName');

        this.memberships = this.organizations.flatMap(x => x.memberships);

        if (!this.account) {
            this.account = new Account();
            this.account.state = 'TX';
            this.account.male = true;
            this.account.city = 'Anytown';
            this.account.country = 'United States';
            this.account.birthDate = '2000-01-01';
            this.account.firstName = firstName;
            this.account.lastName = lastName;
        } else {
            if (this.account.birthDate && this.account.birthDate.indexOf('T') != -1)
                this.account.birthDate = this.account.birthDate.substring(0, this.account.birthDate.indexOf('T'));

            this.account.memberships.forEach(accountMembership => {
                this.selectedMemberships.push(accountMembership.membership);

                if (accountMembership.handicaps.length == 0) {
                    if (accountMembership.membership.hasRiderOneHandicap) {
                        var newHandicap = new MembershipHandicap();
                        newHandicap.riderOne = true;
                        newHandicap.eventType = 'TeamRoping';
                        newHandicap.accountMembershipId = accountMembership.accountMembershipId;

                        accountMembership.handicaps.push(newHandicap);
                    }
                     
                    if (accountMembership.membership.hasRiderTwoHandicap) {
                        var newHandicap = new MembershipHandicap();
                        newHandicap.riderOne = false;
                        newHandicap.eventType = 'TeamRoping';
                        newHandicap.accountMembershipId = accountMembership.accountMembershipId;

                        accountMembership.handicaps.push(newHandicap);
                    }
                }

                if (accountMembership.expiration && accountMembership.expiration.indexOf('T') != -1)
                accountMembership.expiration = accountMembership.expiration.substring(0, accountMembership.expiration.indexOf('T'));
            });

            this.account.displayName = this.account.firstName + ' ' + this.account.lastName;
        }

        Object.assign(this.newUser, this.account);

        this.profileForm = this.formBuilder.group({
            email: new FormControl('email', Validators.compose([
                Validators.pattern('^[a-zA-Z0-9._]+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')
            ])),
            firstName: new FormControl('firstName',  Validators.required),
            lastName: new FormControl('lastName',  Validators.required),
            phone: new FormControl('phone'),
            birthDate: new FormControl('birthDate',  Validators.required),
            gender: new FormControl('gender',  Validators.required),
            streetAddress: new FormControl('streetAddress'),
            country: new FormControl('country',  Validators.required),
            city: new FormControl('city',  Validators.required),
            state: new FormControl('state',  Validators.required),
            zip: new FormControl('zip'),
            membership: new FormControl('membership',  Validators.required),
        });
            
        this.validationMessages = [
            { name: 'email', type: 'required', message: 'Email Address is required.' },
            { name: 'email', type: 'pattern', message: 'Your email address has an incorrect format.' },
            { name: 'firstName', type: 'required', message: 'Firstname is required.' },
            { name: 'lastName', type: 'required', message: 'Lastname is required.' },
            { name: 'birthDate', type: 'required', message: 'Birthdate is required.' },
            { name: 'gender', type: 'required', message: 'Gender is required.' },
            { name: 'country', type: 'required', message: 'Country is required.' },
            { name: 'city', type: 'required', message: 'City is required.' },
            { name: 'state', type: 'required', message: 'State is required.' },
        ];

        this.account.memberships.forEach((accountMembership) => {
            this.addMembershipControl(accountMembership);
        });
    }

    addMembershipControl(accountMembership: AccountMembership) {
        let index = this.account.memberships.indexOf(accountMembership);

        this.profileForm.registerControl('accountMembership_' + index, new FormControl('accountMembership_' + index, Validators.required));
        this.profileForm.registerControl('accountMembership_exp_' + index, new FormControl('accountMembership_exp_' + index, Validators.required));

        this.validationMessages.push(
            { name: 'accountMembership_' + index, type: 'required', message: 'Membership id is required.' },
            { name: 'accountMembership_exp_' + index, type: 'required', message: 'Membership expiration is required.' },
        );
    }

    formatMemberships(memberships: Membership[]) {
        return memberships.map(membership => membership.name + ' (' + this.getOrgName(membership.organizationId) + ')').join(', ');
    }

    getOrgName(orgId: number) {
        const org = this.organizations.find(x => x.id === orgId);
        if (org) {
            return org.name;
        } else {
            console.error(`Organization with id ${orgId} not found.`);
            return null;
        }
    }    
    
    openUserOneSearch(searchEvent) {
        let callback = (data) => {
            if (data && data.buddies && data.buddies.length > 0) {
                this.account = data.buddies[0];
                this.account.displayName = data.buddies[0].firstName + ' ' + data.buddies[0].lastName;                
                this.account.birthDate = new Date(this.account.birthDate).toISOString();

                if (this.secondUser == null)
                    Object.assign(this.newUser, this.account);

                console.log("newUser: ", this.newUser);
            }   
        }

        this.openUserSearch(searchEvent, 'User One Search', callback);
    }

    openUserTwoSearch(searchEvent) {
        let callback = (data) => {
            if (data && data.buddies && data.buddies.length > 0) {
                if (data.buddies[0].id == this.account.id) {
                    this.secondUser.displayName = "Invalid.  Same user.";
                    return;
                }
                
                this.secondUser = data.buddies[0];
                this.secondUser.displayName = data.buddies[0].firstName + ' ' + data.buddies[0].lastName;
                this.secondUser.birthDate = new Date(this.secondUser.birthDate).toISOString();

                if (this.account == null)
                    Object.assign(this.newUser, this.secondUser);
                else {
                    if (!this.newUser.emailAddress && this.secondUser.emailAddress)
                        this.newUser.emailAddress = this.secondUser.emailAddress;

                    if (!this.newUser.firstName && this.secondUser.firstName)
                        this.newUser.firstName = this.secondUser.firstName;

                    if (!this.newUser.lastName && this.secondUser.lastName)
                        this.newUser.lastName = this.secondUser.lastName;

                    if (!this.newUser.birthDate && this.secondUser.birthDate)
                        this.newUser.birthDate = this.secondUser.birthDate;

                    if (!this.newUser.phone && this.secondUser.phone)
                        this.newUser.phone = this.secondUser.phone;

                    if (!this.newUser.streetAddress && this.secondUser.streetAddress)
                        this.newUser.streetAddress = this.secondUser.streetAddress;

                    if (!this.newUser.city && this.secondUser.city)
                        this.newUser.city = this.secondUser.city;

                    if (!this.newUser.state && this.secondUser.state)
                        this.newUser.state = this.secondUser.state;

                    if (!this.newUser.zip && this.secondUser.zip)
                        this.newUser.zip = this.secondUser.zip;
                }          
            }
        }

        this.openUserSearch(searchEvent, 'User Two Search', callback);
    }

    openUserSearch(searchEvent, title, callback) {
        if (this.popoverActive)
			return;

		this.popoverActive = true;

        let popover = this.popoverCtrl.create(UserSearchPopover, {
            searchTitle: title
        }, { cssClass: 'user-search' });
    
        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            callback(data);
        })
    }

    addFamilyMember() {
        let callback = (data) => {
            if (data) {
                let newFamilyMember = new AccountFamily();
                newFamilyMember.accountId = this.account.id;
                newFamilyMember.familyMemberId = data.buddies[0].id;
                newFamilyMember.familyMember = data.buddies[0];

                this.account.familyMembers.push(newFamilyMember);
            }   
        }

        this.openUserSearch(null, 'Family Search', callback);
    }

    deleteFamilyMember(familyMember: AccountFamily) {
        this.account.familyMembers = this.account.familyMembers.filter(x => x.familyMemberId != familyMember.familyMemberId);
    }

    addMembership() {
        if (this.popoverActive)
            return;
        
        this.popoverActive = true;

        let popover = this.popoverCtrl.create(NewMembership, {
            organizations: this.organizations
        }, {
            cssClass: 'page-new-membership'
        });
    
        popover.present();
        popover.onDidDismiss(data => {
            console.log("data", data);
            if (data && data.membership) {
                let accountMembership = new AccountMembership();
                accountMembership.id = '';
                accountMembership.membership = data.membership;

                if (data.membership.id == 25 || data.membership.id ==32)
                    accountMembership.expiration = new Date().getFullYear() + '-11-30';
                else
                    accountMembership.expiration = (new Date().getFullYear() + 1) + '-03-01';                

                if (accountMembership.membership.hasRiderOneHandicap) {
                    var newHandicap = new MembershipHandicap();
                    newHandicap.riderOne = true;
                 
                    accountMembership.handicaps.push(newHandicap)
                }
                 
                if (accountMembership.membership.hasRiderTwoHandicap) {
                    var newHandicap = new MembershipHandicap();
                    newHandicap.riderOne = false;
                 
                    accountMembership.handicaps.push(newHandicap)
                }

                this.account.memberships.push(accountMembership);
                this.addMembershipControl(accountMembership);
            }

            console.log("this.account", this.account);

            this.popoverActive = false;
        });
    }

    deleteMembership(accountMembership: AccountMembership) {
        console.log("deleting ", accountMembership);
        this.account.memberships = this.account.memberships.filter(x => x.membershipId != accountMembership.membershipId);
    }

    save() {
        if (this.account.id) {
            this.saveAccount();
        } else {
            this.addAccount();
        }
    }

    addAccount() {
        let loader = this.loadingCtrl.create({
            content: "Creating account..."
        });
        loader.present();
        
        this.userService.addUserFromStaff(this.account)
        .then(data => {
            if ((data as any).message != null && (data as any).message != undefined) {
                this.alertMessager.showError("Creating Account Failed", (data as any).message);
            } else {
                loader.dismiss();

                if (this.callback)
                    this.callback(data as Account);

                this.nav.pop();
            }
        }, error => { 
            loader.dismiss();
            this.alertMessager.showError("Creating Account Error", error); 
        });
    }

    saveAccount() {
        let loader = this.loadingCtrl.create({
            content: "Saving account..."
        });
        loader.present();

        this.userService.updateAccount(this.account)
        .then(data => {
            if ((data as any).message != null && (data as any).message != undefined) {
                this.alertMessager.showError("Update Account Failed", (data as any).message);
            } else {
                loader.dismiss();

                if (this.callback)
                    this.callback(this.account);

                this.nav.pop();
            }
        }, error => { 
            loader.dismiss();
            console.log('error ', error);

            if (error.error && error.error.value)
                this.alertMessager.showError("Update Account Error", error.error.value.message);
            else
                this.alertMessager.showError("Update Account Error", error); 
        });
    }

    mergeAccounts() {
        if (this.account.id == undefined || this.account.id == null || this.secondUser.id == undefined || this.secondUser.id == null) {
            this.alertMessager.showError('Migrate Error', 'You must select two users.');
            return;
        }

        console.log("UserOne: ", this.account);
        console.log("UserTwo: ", this.secondUser);

        let loading = this.loadingCtrl.create({
            content: 'Merging accounts...',
        });

        this.userService.mergeAccounts(this.newUser, this.account.id, this.secondUser.id).then<any, any>(
            data => {
                loading.dismiss();
                if ((data as any).errorMessage !== undefined) {
                    this.alertMessager.showError('Merge Error', (data as any).errorMessage);
                } else {
                    this.account = new Account();
                    this.secondUser = new Account();
                    this.newUser = new Account();

                    this.toast.create({
                        message: 'Successfully merged accounts.',
                        duration: 2000,
                        position: 'middle'
                    }).present();
                }
            },
            error => {
                loading.dismiss();
                this.alertMessager.showError('Merge Error', error);
            }
        );
    }

    back() {
        this.nav.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/memberships/new-member.ts